var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadsLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.083 8.31c3.28-3.28 7.647-.947 7.221 3.925-.425 4.872-3.441 4.714-3.975 4.714-5.097 0-4.651-5.74.712-5.74 9.618 0 9.037 11.163-.93 11.163-3.91 0-8.987-1.986-8.987-10.705 0-11.163 13.93-14.4 17.753-3.847"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadsLine);
export default __webpack_public_path__ + "static/media/threads_line.c445a1845958e5670949ffc51e6efe72.svg";
export { ForwardRef as ReactComponent };